import { CategoryAttributes } from '@/types'
import { CreateCategoryMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const {
    attributes,
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateCategoryMutation, CategoryAttributes, never, never>({
    defaultValues: {
      name: '',
      parentId: '',
      color: null,
    },
    mutation: CreateMutation,
    resultKey: 'createCategory',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      { formBuilder.buildField({ name: 'Parent', field: 'parentId', type: 'category' }) }
      { !attributes.parentId && formBuilder.buildField({ name: 'Color', field: 'color', type: 'color' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
